import styled from 'styled-components';
import StepButtons from 'components/StepButtons';

export const StyledStepButtons = styled(StepButtons)<{ $isMobile: boolean}>`
  ${({ $isMobile }) => ($isMobile ? ''
    : 'margin-top: 80px;'
  )}
`;
